import { render, staticRenderFns } from "./ContentLoad.vue?vue&type=template&id=baacaa52&scoped=true&"
import script from "./ContentLoad.vue?vue&type=script&lang=js&"
export * from "./ContentLoad.vue?vue&type=script&lang=js&"
import style0 from "./ContentLoad.vue?vue&type=style&index=0&id=baacaa52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baacaa52",
  null
  
)

export default component.exports